import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './amplifyConfig';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './Contexts/AuthProvider';
import { SecurityProvider } from './Contexts/SecurityProvider';
import { NavigationGuardProvider } from './Contexts/NavigationGuardContext';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <NavigationGuardProvider>
            <AuthProvider>
                <SecurityProvider>
                <App />
                </SecurityProvider>
            </AuthProvider>
          </NavigationGuardProvider>
        </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
